// CoralProductCards.tsx
import './CoralProductCards.scss'

import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { CoralAnimatedProductCard } from '@websrc/App/Components/CoralProductCard/CoralAnimatedProductCard'
import { CoralTabs } from '@websrc/App/Components/CoralTab/CoralTabs'
import { CoralMasterCardVisuals } from '@websrc/DataMappers/mapCoralMasterCard'
import { mapCoralWebProductCards } from '@websrc/DataMappers/mapSpot'
import React, { FC, useEffect, useRef, useState } from 'react'

import { CoralMasterCard } from '../../../coral-library/cards/Coral/ContentCard/CoralMasterCard'

type CoralProductCardsProps = ReturnType<typeof mapCoralWebProductCards>

const smVisuals: CoralMasterCardVisuals = {
  subheadSize: 'label-md-regular',
  headlineSize: 'h3-sm',
  contentContainerColor: 'off-white',
  contentPadding: '3xl',
  paddingHeadline: 'sm',
  imageOrientation: 'top',
  imageRatio: '3-2',
  hoverAnimation: 'move-up',
  imageBorder: true,
  buttonHide: true,
  maxHeadlineLines: 2,
  radius: 4,
}

export const CoralProductCards: FC<CoralProductCardsProps> = (props) => {
  const cardRef = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)

  const { single_kit_cards, classroom_bundle_cards, accessories_cards } = props

  // const visuals: CoralMasterCardVisuals = useMemo(
  //   () => (isWidescreen ? smVisuals : smVisuals),
  //   [isWidescreen]
  // )
  useEffect(() => {
    const node = cardRef.current
    if (!node) return
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
        }
      },
      { threshold: 0.22 }
    )
    observer.observe(node)
  }, [])

  const tabs = [
    single_kit_cards?.animated_card?.length > 0 && {
      label: single_kit_cards.name,
      content: (
        <div ref={cardRef}>
          <CoralCardsSlider forceRow={true}>
            {single_kit_cards.animated_card.map((card, idx) => (
              <CoralAnimatedProductCard visible={visible} {...card} key={idx} />
            ))}
          </CoralCardsSlider>
        </div>
      ),
    },
    classroom_bundle_cards?.cards?.length > 0 && {
      label: classroom_bundle_cards.name,
      content: (
        <CoralCardsSlider forceRow={true}>
          {classroom_bundle_cards.cards.map((card, id) => (
            <div className={'coral-product-cards__product-card'} key={id}>
              <CoralMasterCard visuals={smVisuals} {...card} />
            </div>
          ))}
        </CoralCardsSlider>
      ),
    },
    accessories_cards?.cards?.length > 0 && {
      label: accessories_cards.name,
      content: (
        <CoralCardsSlider forceRow={true}>
          {accessories_cards.cards.map((card, id) => (
            <div className={'coral-product-cards__product-card'} key={id}>
              <CoralMasterCard visuals={smVisuals} {...card} />
            </div>
          ))}
        </CoralCardsSlider>
      ),
    },
  ].filter(Boolean) as { label: string; content: React.ReactNode }[]

  const [activeIndex, setActiveIndex] = useState(0)
  const handleTabChange = (index: number) => {
    if (index === 0) {
      setVisible(false)
      setTimeout(() => setVisible(true), 10)
    } else {
      setVisible(false)
    }
    setActiveIndex(index)
  }

  return (
    <div className={'category-coral-spot'} id={'coral-product-cards'}>
      <CoralTabs activeIndex={activeIndex} onTabChange={handleTabChange} tabs={tabs} />
      <div className={'coral-product-cards__content'}>{tabs[activeIndex]?.content}</div>
    </div>
  )
}
